export const NAME_VALIDATION = /^([\u00c0-\u01ffa-z'\- ])+$/i;
